import Controller from "../Engine/Controller";
import cfJS from "../Engine/cfJS";

class Dialog extends Controller {
    constructor (dom,alias) {
        super(dom, "Dialog");

        this.alias = alias;
        this.bg = cfJS.querySelector(this.domNode,">.background_dialog");
        this.dialog = cfJS.querySelector(this.domNode,">.dialog_window");

        this._addWindowEvent();
    }
    /*
    * add window event/trigger to open modal
    */
    _addWindowEvent() {
        let that = this,
            dom = this.domNode;

        window["client_trigger_"+this.alias] = function () {
            if (!dom.classList.contains("show"))
                that.show();
            else
                that.hide();

            return that;
        };

        cfJS.addListener(this.bg, "click", function () {
            that.hide();
        });
    }
    /*
    * show dialog window
    */
    show() {
        let dom = this.domNode;

        /*if (dom.classList.contains("show"))
            dom.classList.remove("show");
        else*/

        cfJS.style(this.domNode,"opacity",0);
        cfJS.style(this.domNode,"display","block");
        dom.classList.add("show");

        cfJS.style(this.dialog,"margin-left",this.dialog.offsetWidth/2*-1+"px");
        cfJS.style(this.dialog,"margin-top",this.dialog.offsetHeight/2*-1+"px");
        cfJS.style(this.domNode,"opacity",1);
    }
    /*
    * hide dialog window
    */
    hide() {
        let dom = this.domNode;
        cfJS.style(this.domNode,"display","none");
        dom.classList.remove("show");
    }
}

window.Dialog = Dialog;